export function guideImage(guide = {}) {
 let sections=guide.sections;
 for(let i=0;i<2&&typeof sections==='string';i++){try{sections=JSON.parse(sections);}catch{sections=[];}}
 const section=(Array.isArray(sections)?sections:[]).find(s=>s?.type==='image'&&((s.data||s).imageUrl));
 const image=section&&(section.data||section);
 return {src:image?.imageUrl||null,alt:image?.altText||guide.title||'Guide',sectionId:section?.id||null};
}
